import React from 'react'

const ViewBarArrowAlphDown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.3 28.3">
    <path fill="none" d="M18 10.4h4.6l-2.4-6z" />
    <path d="M19.2 2.5l-5.3 13.4h2l1.4-3.7h5.9l1.5 3.7h2L21.4 2.5h-2.2zM18 10.4l2.3-6 2.3 6H18z" />
    <path d="M14.6 20.9c-.4-.4-1.2-.4-1.6 0l-3.5 3.5V1.1C9.4.5 8.9 0 8.3 0S7.1.5 7.1 1.1v23.3l-3.5-3.5c-.4-.4-1.2-.4-1.6 0-.2.2-.3.5-.3.8 0 .3.1.6.3.8L7.5 28c.2.2.5.3.8.3.3 0 .6-.1.8-.3l5.5-5.5c.2-.2.3-.5.3-.8 0-.3-.1-.6-.3-.8z" />
  </svg>
)

export default ViewBarArrowAlphDown
